<script>
export default
{
    name: 'background-illustration',

    props:
    {
        image: { type: String, required: true },
        message: { type: String, required: false }
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='background-illustration'>
                <inline-svg class='image' src={this.image} />
                <span class='message'>
                    { this.message }
                    {this.$slots.default}
                </span>
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.background-illustration
{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 110px;

    .image
    {
        width: 30%;
        margin-bottom: 15%;
        height: auto;
        filter: var(--theme-background-image-filter);
        opacity: 0.2;

        .OnTablet({
            width: 25%;
        }); 

        .OnDesktop({
            width: 10%;
            margin-top: 10%;
            margin-bottom: 5%;
        });
    }

    .message
    {
        font-size: 18px;
        text-align: center;
        white-space: break-spaces;
        color: var(--theme-background-text-color);

        .OnTablet({
            font-size: 2.5vh;
        });

        .OnDesktop({
            margin-right: 20%;
            margin-left: 20%;
            min-width: 25vw;
        });

        b
        {
            color: var(--theme-text-color-extra-light);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/BackgroundIllustration.vue